import { trackPromise } from "react-promise-tracker";
import { axiosBridge } from "../network/AxiosBridge";
import { API_URL, StatusCodes } from "../network/Configurations";

const getLocationList = (): Promise => {
  return new Promise((resolve, reject) => {
    trackPromise(
      axiosBridge
        .get(API_URL.GET_LOCATION_LIST)
        .then((response) => {
          if (
            response.data.code === StatusCodes.SUCCESS ||
            response.data.code === StatusCodes.NO_DATA_FOUND
          ) {
            resolve(response.data);
          } else reject(response.data);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        })
    );
  });
};

const getExperienceCategoryList = (params: any): Promise => {
  return new Promise((resolve, reject) => {
    trackPromise(
      axiosBridge
        .get(API_URL.GET_EXPERIENCE_CATEGORY, { params })
        .then((response) => {
          if (
            response.data.code === StatusCodes.SUCCESS ||
            response.data.code === StatusCodes.NO_DATA_FOUND
          ) {
            resolve(response.data);
          } else reject(response.data);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        })
    );
  });
};

const getReportTypeList = (): Promise => {
  return new Promise((resolve, reject) => {
    trackPromise(
      axiosBridge
        .get(API_URL.GET_REPORT_TYPE_LIST)
        .then((response) => {
          if (
            response.data.code === StatusCodes.SUCCESS ||
            response.data.code === StatusCodes.NO_DATA_FOUND
          ) {
            resolve(response.data);
          } else reject(response.data);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        })
    );
  });
};

const reportProfile = (request: any): Promise => {
  return new Promise((resolve, reject) => {
    trackPromise(
      axiosBridge
        .post(API_URL.REPORT_PROFILE, request)
        .then((response) => {
          if (response.data.code === StatusCodes.SUCCESS) {
            resolve(response.data);
          } else reject(response.data);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        })
    );
  });
};

const reportJob = (request: any): Promise => {
  return new Promise((resolve, reject) => {
    trackPromise(
      axiosBridge
        .post(API_URL.REPORT_JOB, request)
        .then((response) => {
          if (response.data.code === StatusCodes.SUCCESS) {
            resolve(response.data);
          } else reject(response.data);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        })
    );
  });
};

const getExperienceTypeList = (): Promise => {
  return new Promise((resolve, reject) => {
    trackPromise(
      axiosBridge
        .get(API_URL.GET_EXPERIENCE_TYPE_LIST)
        .then((response) => {
          if (
            response.data.code === StatusCodes.SUCCESS ||
            response.data.code === StatusCodes.NO_DATA_FOUND
          ) {
            resolve(response.data);
          } else reject(response.data);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        })
    );
  });
};

export const GeneralService = {
  getLocationList,
  getReportTypeList,
  reportJob,
  reportProfile,
  getExperienceCategoryList,
  getExperienceTypeList,
};
